"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_expandable_section_1 = require("../expandable-section/awsui-expandable-section");
var SideNavigationItemWrapper = /** @class */ (function (_super) {
    __extends(SideNavigationItemWrapper, _super);
    function SideNavigationItemWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideNavigationItemWrapper.prototype.findSection = function () {
        return new awsui_expandable_section_1.default(this.find('.awsui-side-navigation__sub-navigation--section').getElement());
    };
    SideNavigationItemWrapper.prototype.findExpandableLinkGroup = function () {
        return new awsui_expandable_section_1.default(this.find('.awsui-side-navigation__sub-navigation--expandable-link-group').getElement());
    };
    SideNavigationItemWrapper.prototype.findDivider = function () {
        return this.find('.awsui-side-navigation__divider');
    };
    SideNavigationItemWrapper.prototype.findLink = function () {
        return this.find('.awsui-side-navigation__link');
    };
    SideNavigationItemWrapper.prototype.findSectionTitle = function () {
        return this.find('.awsui-side-navigation__title');
    };
    SideNavigationItemWrapper.prototype.findItemByIndex = function (index) {
        return new SideNavigationItemWrapper(this.find("li:nth-child(" + index + ")").getElement());
    };
    SideNavigationItemWrapper.prototype.findItems = function () {
        return this.findAll('li');
    };
    return SideNavigationItemWrapper;
}(dom_1.ElementWrapper));
exports.SideNavigationItemWrapper = SideNavigationItemWrapper;
var SideNavigationWrapper = /** @class */ (function (_super) {
    __extends(SideNavigationWrapper, _super);
    function SideNavigationWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideNavigationWrapper.prototype.findHeaderLink = function () {
        return this.find('.awsui-side-navigation__header-link');
    };
    SideNavigationWrapper.prototype.findLinkByHref = function (href) {
        return this.find(".awsui-side-navigation__link[href=\"" + href + "\"]");
    };
    SideNavigationWrapper.prototype.findActiveLink = function () {
        return this.find('.awsui-side-navigation__link--active');
    };
    SideNavigationWrapper.prototype.findItemByIndex = function (index) {
        return new SideNavigationItemWrapper(this.find(".awsui-side-navigation__list--root > li:nth-child(" + index + ")").getElement());
    };
    return SideNavigationWrapper;
}(dom_1.ComponentWrapper));
exports.default = SideNavigationWrapper;
//# sourceMappingURL=awsui-side-navigation.js.map